import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as yup from "yup";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { login } from "../redux/handlers/auth/login.handler";
import { VER } from "constants/server/api";
import { LOGO_URL, SERVER_NAME } from "constants/server/config";
import { env } from "env";
export function Login() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    // const { isloading, setIsLoading } = useGlobalLoaderContext();
    var loginReducer = useAppSelector(function(state) {
        return state.loginReducer;
    });
    var schema = yup.object().shape({
        username: yup.string().required(),
        password: yup.string().required()
    });
    var _useState = _sliced_to_array(useState("password"), 2), inputtype = _useState[0], setInputtype = _useState[1];
    var _useState1 = _sliced_to_array(useState({
        username: "",
        password: "",
        remember: false
    }), 2), formData = _useState1[0], setFormData = _useState1[1];
    var handleLogin = function(values) {
        dispatch(login(values, navigate, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        if (loginReducer.data && loginReducer.data.data.accessToken) {
            localStorage.setItem("accessToken", loginReducer.data.data.accessToken);
            navigate("/dashboard");
        }
    }, [
        loginReducer.isFetching
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "loginpage bg-white",
        children: /*#__PURE__*/ _jsxs(Row, {
            className: "g-0",
            children: [
                /*#__PURE__*/ _jsx(Col, {
                    lg: 7,
                    xl: 8,
                    className: "d-none d-xl-block",
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: "/images/banner_login.png",
                        className: "w-100",
                        style: {
                            height: "100vh",
                            objectFit: "cover"
                        }
                    })
                }),
                /*#__PURE__*/ _jsx(Col, {
                    className: "d-flex justify-content-center align-items-center h-100vh",
                    children: /*#__PURE__*/ _jsx(Card, {
                        className: "box-login",
                        children: /*#__PURE__*/ _jsxs(Card.Body, {
                            className: "",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        src: env.REACT_APP_LOGO_URL,
                                        width: 200,
                                        className: "mb-4 mx-auto"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-20 fw-500 tc-5",
                                    children: "ยินดีต้อนรับเข้าสู่ระบบ"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-20 fw-500 mb-2 tc-5",
                                    children: "PARDESCO Backoffice"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-18 fw-500 mb-3 tc-1",
                                    children: "เข้าสู่ระบบ"
                                }),
                                /*#__PURE__*/ _jsx(Formik, {
                                    initialValues: formData,
                                    validationSchema: schema,
                                    onSubmit: handleLogin,
                                    children: function(param) {
                                        var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, isValid = param.isValid, errors = param.errors, values = param.values;
                                        return /*#__PURE__*/ _jsxs(Form, {
                                            noValidate: true,
                                            onSubmit: handleSubmit,
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "username",
                                                    placeholder: "อีเมลหรือเบอร์โทรศัพท์",
                                                    onChange: handleChange,
                                                    isValid: touched.username && !errors.username,
                                                    isInvalid: !!errors.username,
                                                    className: "form-st-1 mb-3"
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "position-relative",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: inputtype,
                                                            name: "password",
                                                            placeholder: "รหัสผ่าน",
                                                            onChange: handleChange,
                                                            isValid: touched.password && !errors.password,
                                                            isInvalid: !!errors.password,
                                                            className: "form-st-1 mb-3"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Button, {
                                                            type: "button",
                                                            className: "btn btn-change-type-password",
                                                            onClick: function() {
                                                                return inputtype == "password" ? setInputtype("text") : setInputtype("password");
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "d-flex justify-content-between my-4",
                                                    children: /*#__PURE__*/ _jsx(Form.Check // prettier-ignore
                                                    , {
                                                        type: "checkbox",
                                                        id: "remember",
                                                        label: "จำรหัสผ่าน",
                                                        defaultChecked: true
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "submit",
                                                    className: "btn-login w-100 mb-4",
                                                    disabled: loginReducer.isFetching,
                                                    children: "เข้าสู่ระบบ"
                                                })
                                            ]
                                        });
                                    }
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
